<template>
	<div name="hrms-num-input" class="box-number">
    <input v-model="inputNumber"
           class="input-number align-center"
           @blur="concatDecimal()"
           @focus="setActiveInput()"
           :name="name"
           :class="{ 'input-error' : hasError }"
           :disabled="disabled"
           ref="numberInput" />
	</div>
</template>

<script>
export default {
  name: 'hrms-num-input',
  data () {
    return {
      inputNumber: this.value,
      activeInput: false
    }
  },
  created () {
    this.concatDecimal()
  },
  watch: {
    'value' () {
      this.inputNumber = this.value.toString()
      if (!this.activeInput) {
        this.concatDecimal()
      }
    },
    'inputNumber' () {
      if (this.inputNumber !== '') {
        this.inputNumber = this.numberConvertFormat(this.inputNumber)
      } else {
        this.inputNumber = ''
      }
      this.$emit('input', this.inputNumber)
    }
  },
  methods: {
    numberConvertFormat (numberInput) {
      let numberInputConverted = ''
      let splitInput = numberInput.split('.')
      let inputInteger = splitInput[0].replace(/[^0-9]/g, '')
      inputInteger = inputInteger.substr(0, this.numLength)
      if (inputInteger !== '' && inputInteger !== '0') {
        numberInputConverted = parseFloat(inputInteger).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        numberInputConverted = '0'
      }
      if (this.activeInput) {
        if (typeof splitInput[1] !== 'undefined') {
          let inputDecimal = this.calDecimal(splitInput[1])
          numberInputConverted = numberInputConverted + (this.decimal === 0 ? '' : '.' + inputDecimal)
        }
      } else {
        numberInputConverted = numberInputConverted + (this.decimal === 0 ? '' : '.' + this.rpad(splitInput[1], '0', this.decimal))
      }
      return numberInputConverted
    },
    concatDecimal () {
      this.activeInput = false
      if (this.inputNumber !== '') {
        let splitInput = (this.inputNumber.toString().indexOf('.') >= 0) ? this.inputNumber.split('.') : [this.inputNumber]
        if (typeof splitInput[1] === 'undefined') {
          this.inputNumber = this.inputNumber + (this.decimal === 0 ? '' : '.' + this.rpad('0', '0', this.decimal))
        } else {
          this.inputNumber = this.numberConvertFormat(this.inputNumber)
        }
      } else {
        this.inputNumber = ''
      }
    },
    calDecimal (inputDecimal) {
      return inputDecimal.replace(/[^0-9]/g, '').substr(0, this.decimal)
    },
    rpad (valStr, padString, length) {
      let str = valStr
      while (str.length <= length) {
        str = str + padString
      }
      return str.substr(0, length)
    },
    setActiveInput () {
      this.activeInput = true
    }
  },
  props: {
    value: {
      type: String,
      required: true,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'numberInput'
    },
    numFormat: {
      type: String
    },
    numLength: {
      type: Number
    },
    decimal: {
      type: Number,
      default: 2
    }
  }
}
</script>

<style src="./style.scss" lang='scss' scoped></style>



// WEBPACK FOOTER //
// component.vue?1dc1560c